import { State } from '~/store/types';

import AlertActivity from './AlertActivity';
import Global from './Global';

class GraphsStore {
  alertActivity: AlertActivity;
  global: Global;
  constructor(rootStore: State) {
    this.alertActivity = new AlertActivity(rootStore);
    this.global = new Global(rootStore);
  }
}

export default GraphsStore;
